"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allExtensionsLoaded = exports.loadExtensions = exports.check = void 0;
require("./page-interface-generated");
function check(gl) {
    function setError(message) {
        Page.Demopage.setErrorMessage("webgl-requirements", message);
    }
    var mediump = gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.MEDIUM_FLOAT);
    if (mediump.precision < 23) {
        Page.Demopage.setErrorMessage("webgl-requirements", "Your device only supports low precision float in fragment shader.\n" +
            "The simulation will not run.");
        return false;
    }
    return true;
}
exports.check = check;
var allExtensionsLoaded = false;
exports.allExtensionsLoaded = allExtensionsLoaded;
function loadExtensions(gl, extensions) {
    exports.allExtensionsLoaded = allExtensionsLoaded = true;
    var i = 0;
    for (var _i = 0, extensions_1 = extensions; _i < extensions_1.length; _i++) {
        var ext = extensions_1[_i];
        if (!gl.getExtension(ext)) {
            Page.Demopage.setErrorMessage("no-ext" + i, "Cannot load WebGL extension '" + ext + "'.");
            exports.allExtensionsLoaded = allExtensionsLoaded = false;
        }
        ++i;
    }
}
exports.loadExtensions = loadExtensions;
